import {
  validateEmail,
  validateFile,
  validatelCountrySateContact,
  validatelCountrySate,
  validatelMobileNo,
  validateName,
  validateDesc,
  validateDesignation,
  validateSelectField,
} from "../common/dependencies/utils/validation";

export default {
  validateStep1: (params) => {
    const {
      entity_name,
      contact_number,
      email_id,
      state,
      city,
      user_type,
      query_type,
      message,
    } = params;

    let formStatus = {};
    const entitynameStatus = validateName(
      entity_name,
      "Please Enter Entity Name"
    );
    const contactnumberStatus = validatelMobileNo(
      contact_number,
      "Please Enter Your Contact Number"
    );
    const emailStatus = validateEmail(email_id, "Please Enter Your Email Id");
    const messagePicStatus = validateDesc(
      message,
      "Please Enter Query Description"
    );
    const StateStatus = validatelCountrySateContact(
      state,
      "Please Select State",
      "IN"
    );
    const cityStatus = validatelCountrySateContact(city, "Please Select City ");
    const query_typeStatus = validateDesignation(
      query_type,
      "Please Select Query Type "
    );
    const user_typeStatus = validateDesignation(
      user_type,
      "Please Select User Type "
    );

    formStatus = {
      entity_name: entitynameStatus.error,
      contact_number: contactnumberStatus.error,
      email_id: emailStatus.error,

      state: StateStatus.error,
      city: cityStatus.error,
      user_type: user_typeStatus.error,
      query_type: query_typeStatus.error,
      message: messagePicStatus.error,
      hasErrors:
        entitynameStatus.hasError ||
        contactnumberStatus.hasError ||
        emailStatus.hasError ||
        messagePicStatus.hasError ||
        StateStatus.error ||
        cityStatus.error ||
        query_typeStatus.error ||
        user_typeStatus.error,
    };
    return formStatus;
  },
};
